class HeaderMenu extends HTMLElement {
    constructor() {
        super();

        this.container = this.querySelector(".header__inline-menu > ul");
        this.mainItemDetails = this.querySelector(
            "[data-main-item-menu] details"
        );
        this.itemsDetails = this.querySelectorAll("[data-items-menu] details");
        this.overlay = document.querySelector(".header-menu__overlay-element");

        /* activate top level nowrap */
        if (this.container && this.container.classList.contains("nowrap")) {
            new ResizeObserver(this.moveLastItems.bind(this)).observe(
                this.container
            );
            window.addEventListener(
                "resize",
                debounce(this.moveLastItems.bind(this), 200)
            );
            this.nowrapTemplate();
        }

        /* dropdown-inner  - remove redundant item images. Allow to show only one Item-Image per Dropdown Inner */
        const dropdownInner = this.querySelectorAll(
            ".dropdown-inner.full-width"
        );
        this.container && dropdownInner
            ? this.removeOddItemImages(dropdownInner)
            : "";

        /* activate top level items on hover */
        this.querySelectorAll("details-disclosure > details").forEach(
            (detail) => {
                detail.addEventListener(
                    "mousestop",
                    this.activateTopLevelOnHover.bind(this)
                );
                detail.addEventListener(
                    "mouseleave",
                    debounce(this.mouseLeave.bind(this), 200)
                );
            }
        );

        if (!this.itemsDetails.length) return;

        this.itemsDetails.forEach((detail) => {
            /* megamenu - open dropdown inner always */
            if (detail.lastElementChild.dataset.typeMenu == "full-width") {
                detail.setAttribute("open", true);
            }
        });
    }

    shevronPosition(detail) {
        if (detail.lastElementChild.getBoundingClientRect().left === 0) {
            detail.lastElementChild.children[1].style.left =
                detail.offsetLeft + detail.offsetWidth / 2 - "5" + "px";
        } else if (detail.lastElementChild.style.right == "0px") {
            /* fix position - small menu-shevron of last item menu
             * ignore nowrap dropdown inner          *
             */
            if (
                !detail.lastElementChild.children[0].classList.contains(
                    "submenu-nowrap"
                )
            ) {
                detail.lastElementChild.children[1].style.right =
                    detail.offsetWidth / 2 - "5" + "px";
            }
        } else {
            if (detail.parentElement.parentElement.dataset.mainItemMenu) return;
            else
                detail.lastElementChild.children[1].style.left =
                    detail.offsetWidth / 2 - "5" + "px";
        }
    }

    activateTopLevelOnHover(e) {
        let detail = e.target.closest("details");

        /* first item of small menu uses separate event */
        if (detail.parentElement.parentElement.dataset.mainItemMenu) {
            this.container.style.overflow = "visible";
            this.mouseOver(detail);
            return;
        }

        if (detail.parentElement.nodeName === "DETAILS-DISCLOSURE") {
            detail.setAttribute("open", true);

            this.shevronPosition(detail);
        }
    }

    // resetItemsLevel(item, increment=-1) {

    // }

    // reloadTopLevelMenu() {
    //   let visibleTopItems = this.container.querySelectorAll(".nowrap > li[item-index]")

    //   if (this.getLiWidthMainListMenu(visibleTopItems) < parseInt(this.container.style.maxWidth))
    //     visibleTopItems.forEach( item => {
    //       this.resetItemsLevel(item)
    //     });
    // }

    getLiWidthMainListMenu(lis) {
        let liWidth = [];
        lis.forEach((li, i) => {
            liWidth[i] = parseInt(li.offsetWidth, 10);
        });

        return liWidth.reduce((acc, curVal) => acc + curVal, 0);
    }

    moveLastItems() {
        if (window.innerWidth < 980) return;

        let topLevelItems = this.container.querySelectorAll("li[item-index]");
        /* get width of all li-items of main menu */
        let liWidth = this.getLiWidthMainListMenu(topLevelItems);

        if (this.container.parentElement.offsetWidth > liWidth) return;

        const nowrapItem = this.container.querySelector("#nowrap-item");
        const nowrapList = nowrapItem.querySelector(".nowrap-inner > ul");

        /* main-list menu set max-width */
        this.container.style.maxWidth =
            this.container.parentElement.offsetWidth > 960
                ? this.container.parentElement.offsetWidth + "px"
                : "960px";

        //this.reloadTopLevelMenu()

        let listExceedItems = [];

        /* toggle attribute and visibility class */
        topLevelItems.forEach((item) => {
            const nowrapOffsetWth = nowrapItem.offsetWidth
                ? nowrapItem.offsetWidth
                : 72;
            /* fix for desktop screens */
            let itemsOffset =
                item.offsetLeft +
                item.offsetWidth +
                nowrapOffsetWth -
                this.container.offsetLeft;

            if (
                window.innerWidth < 1200 &&
                item.offsetLeft + item.offsetWidth >
                    parseInt(this.container.style.maxWidth)
            ) {
                item.setAttribute("shift-item", true);
                /* create list of exceeded items */
                listExceedItems.push(item);
            } else if (
                window.innerWidth > 1200 &&
                itemsOffset > parseInt(this.container.style.maxWidth)
            ) {
                item.setAttribute("shift-item", true);
                /* create list of exceeded items */
                listExceedItems.push(item);
            } else {
                item.removeAttribute("shift-item");
            }
        });

        if (!listExceedItems.length || !nowrapList) return;

        listExceedItems.forEach((item) => {
            if (item.hasAttribute("shift-item")) nowrapList.prepend(item);
        });

        /* show and activate nowrap item if nowrap list is not empty */
        if (nowrapList.children.length > 0) {
            nowrapItem.style.display = "block";
        }
    }

    nowrapTemplate() {
        const template =
            '<li data-items-menu style="display:none" id="nowrap-item" top-level>' +
            "<details-disclosure>" +
            "<details>" +
            '<summary class="header__menu-item header__menu-item-top header__menu-item-nowrap small list-menu__item focus-inset">' +
            '<a href="#" class="menu-item-top list-menu__item focus-inset list-menu__item--active">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16">' +
            '<path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>' +
            "</svg>" +
            '<span style="visibility: hidden; width: 0; overflow: hidden;">More</span>' +
            "</a>" +
            '<span class="menu-shevron"></span>' +
            "</summary>" +
            '<div class="dropdown-inner nowrap nowrap-inner" style="right:0px">' +
            '<ul class="header__submenu submenu-nowrap list-menu link--text motion-reduce" role="list" data-columns="1">' +
            "</div>";
        "</details>" + "</details-disclosure>" + "</li>";
        const html = new DOMParser().parseFromString(template, "text/html");
        let more = html.getElementsByTagName("li");

        for (let i = 0; i < more.length; i++) {
            this.container.appendChild(more[i]);
        }
    }

    showOverlay() {
        if (this.overlay.style.display == "")
            this.overlay.style.display = "block";

        if (!this.overlay.classList.contains("shown"))
            setTimeout(() => {
                this.overlay.classList.add("shown");
            }, 100);
    }

    removeOverlay() {
        this.overlay.classList.remove("shown");
        setTimeout(() => {
            this.overlay.style.display = "";
        }, 200);
    }

    getSubMenuHeight(submenu) {
        this.subMenuHeight =
            submenu.getBoundingClientRect().bottom -
            submenu.getBoundingClientRect().top;
        return this.subMenuHeight;
    }

    setMinHeight(detail) {
        let childListsMenu = detail.querySelectorAll(
            ".childlist-menu--disclosure"
        );

        /* set childlist height as submenu height */
        if (
            !childListsMenu.length ||
            !detail.parentElement.parentElement.dataset.mainItemMenu
        )
            return;

        childListsMenu.forEach((childList) => {
            childList.style.minHeight = this.subMenuHeight
                ? `${this.subMenuHeight}px`
                : `${this.getSubMenuHeight(detail.querySelector("ul"))}px`;
        });
    }

    mouseOver(detail) {
        detail.querySelectorAll("details").forEach((childDetail) => {
            /* show overlay only for main (first) small item menu */
            if (detail.parentElement.parentElement.dataset.mainItemMenu)
                this.showOverlay();

            childDetail.addEventListener("mouseover", (evt) => {
                this.mouseOver(childDetail);
            });
            childDetail.addEventListener(
                "mouseleave",
                this.mouseChildLeave.bind(this)
            );
        });

        detail.setAttribute("open", true);
        this.setMinHeight(detail);
    }

    mouseLeave(event) {
        let detail = event.target;
        if (
            detail.parentElement.parentElement.closest("ul.submenu-nowrap") !==
            null
        )
            return;

        this.subMenuHeight = false;
        detail.removeAttribute("open");
        if (
            detail.parentNode.closest("li").hasAttribute("data-main-item-menu")
        ) {
            this.removeOverlay();
        }
    }

    mouseChildLeave(event) {
        /* first item of small menu */
        this.subMenuHeight = false;
        if (event.target.hasAttribute("open")) {
            setTimeout(() => {
                event.target.removeAttribute("open");
            }, 200);
        }
    }

    removeOddItemImages(dropdownInner) {
        dropdownInner.forEach((item) => {
            let el = item.children[0];
            if (el && el.childNodes.length > 2) {
                let childs = el.children;
                for (var i in childs) {
                    if (i > 1 && childs[i])
                        childs[i].classList.add("odd-image-item");
                }
            }
            /* use extra class to update dropdown width with item-image */
            if (el && el.children[1]) {
                el.classList.add("inner--with-image");
            }
        });

        document.querySelectorAll(".odd-image-item").forEach((item) => {
            item.remove();
        });
    }
}

customElements.define("header-menu", HeaderMenu);

/* create custom event for better behavior on top level mouseover */
(function (mouseStopDelay) {
    var timeout;
    document.addEventListener("mouseover", function (e) {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            var event = new CustomEvent("mousestop", {
                detail: {
                    clientX: e.clientX,
                    clientY: e.clientY,
                },
                bubbles: true,
                cancelable: true,
            });
            e.target.dispatchEvent(event);
        }, mouseStopDelay);
    });
})(150);
